import { Field } from "@types";
import { FC } from "react";
import { FieldValues, UseFormRegister } from "react-hook-form";

import { Label } from "./Label";
import s from "./TextArea.module.scss";

interface Props extends Field {
  register: UseFormRegister<FieldValues>;
}

export const TextAreaField: FC<Props> = ({ label, id, name, register, placeholder, required }) => (
  <>
    <Label id={id} label={label} required={required} />
    <textarea
      id={id}
      className={s.TextArea}
      placeholder={placeholder}
      required={required}
      {...register(name, { required })}
    />
  </>
);
